import { AfterViewInit, OnDestroy } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { ExportgridComponent } from '../grid/exportgrid/exportgrid.component';
import { AddproductquickmenuComponent } from './addproductquickmenu/addproductquickmenu.component';
@Component({
  selector: 'app-productquickmenu',
  templateUrl: './productquickmenu.component.html',
  styleUrls: ['./productquickmenu.component.css']
})
export class ProductquickmenuComponent implements OnInit, AfterViewInit, OnDestroy {


  quickmenuColl: any = [];

  isadd: boolean = false;
  isedit: boolean = false;
  isdelete: boolean = false;
  isview: boolean = false;
  isprint: boolean = false;
  isexport: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "ProductQuickMenu";

  searchtxt: any = "";

  columnDefs = [
   
    { headerName: 'Product', field: 'productname' },
  

  ]

  gridOptions = {
    enableactioncol: true,
    columnDefs: this.columnDefs,
  };

 

  constructor(private appService: DhukanDataService, public router: Router,
    private confirmationDialogService: ConfirmationDialogService, private toastr: ToastrService,
    private productFindService: NgbModal, public loginService: LoginDataService) { this.fnServiceChanges(); }

  //User Check
  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckUser()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }


  ngOnInit() {
    try {



      if (this.loginService.fnCheckUser()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    this.fngetProductQuickMenu();
  }

  fnCheckPrivilage() {

    this.isadd = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE');
    this.isedit = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER');
    this.isdelete = this.loginService.fnCheckUserRoleAction(this.formname, 'DELETE');
    this.isview = this.loginService.fnCheckUserRoleAction(this.formname, 'VIEW');
    this.isprint = this.loginService.fnCheckUserRoleAction(this.formname, 'PRINT');
    this.isexport = this.loginService.fnCheckUserRoleAction(this.formname, 'EXPORT');
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }



  ngAfterViewInit(): void {

  }

  ngOnDestroy(): void {

  }

  fngetProductQuickMenu() {

    if (this.showProgress) {
      return;
    }

    this.fnShowProgress();
    var data = {
      'quickmenuid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getProductQuickMenu(data)
      .subscribe(
        (res) => {

          this.fnHideProgress();
          if (res.json().status == 200) {
            this.quickmenuColl = res.json().result;
          
            this.fnSetDataTable();
          }
          else if (res.json().status == 400) {
            this.toastr.error('Error', res.json().err_field);
          }


        },
        (err) => {
          this.fnHideProgress();
          this.toastr.error('Error', err);
        })
  }

  fnAddProductQuickMenu() {
    try {
      const modalRef = this.productFindService.open(AddproductquickmenuComponent, { size: <any>'xxl', backdrop: 'static' });


      modalRef.componentInstance.ngOnInit();

      modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

        this.fngetProductQuickMenu();

      });


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }


 
  public fnDeleteConfirm(pBO) {
   
    try {
      var deptid = pBO.quickmenuid
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete Product?')
        .then((confirmed) => {
          if (confirmed) {
            this.fnDeleteProductQuickMenu(deptid)
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnDeleteProductQuickMenu(deptid) {
   
  
    var data = {
      'quickmenuid': deptid,
    }
    this.appService.fnDeleteProductQuickMenu(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.toastr.success('', " The Product has been deleted successfully.");

            this.fnInsertActivityLog('DELETE', deptid, this.fnGetDescription(deptid));

            this.fngetProductQuickMenu();
          } else {
            this.toastr.error('', res.json().err_field);
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  //Grid





  fnActionDeleteClick(data) {
    if (!this.isdelete) {
      return;
    }

    this.fnDeleteConfirm(data.quickmenuid);


  }

  fnActionExportClick()  {
    // const modalRef = this.productFindService.open(ExportgridComponent, { size: <any>'xxl', backdrop: 'static' });
    // modalRef.componentInstance.doctype = this.formname;
    // modalRef.componentInstance.columnDefs = this.columnDefs;
    // modalRef.componentInstance.contentColl = this.pr;
    // modalRef.componentInstance.fnSetTable();
    // modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
  
    
    // });
  }


  private fnSetDataTable() {

  }


  fnPrintData() {
    try {


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnExportData() {
    try {


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }


  fnGetDescription(id) {
    const index = this.quickmenuColl.findIndex(sku => sku.quickmenuid === id);

    if (index) {
      return this.quickmenuColl[index].productid;
    }
    else {
      return "";
    }

  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res)=>{
        },
        (err)=>{

        });

    } catch {

    }
  }



  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }




}
